import { defineCustomElement } from '@tyler-components-web/core';
import { QuantityFieldComponent } from './quantity-field';
export * from './quantity-field-adapter';
export * from './quantity-field-constants';
export * from './quantity-field-foundation';
export * from './quantity-field';
export function defineQuantityFieldComponent() {
    defineCustomElement(QuantityFieldComponent);
}
